import CommonUtil from '@/common/utils/CommonUtil'
import { Component, Vue } from 'vue-property-decorator'

import CAHG1230ViewModel from './CAHG1230ViewModel'
import CAHG1230Service from './CAHG1230Service'

import BreadcrumbsDisplay from '@/components/layout/breadcrumbs/Breadcrumbs.vue'
import CommonConstants from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import TransportService from '@/common/TransportService'
import $ from 'jquery'
import { fixedContent, fixedContentNoLogin } from '@/assets/js/main.js'
import Store from '@/common/utils/Store'

@Component({
  name: 'CAHG1230',
  components: {
  BreadcrumbsDisplay
  }
  })
export default class CAHG1230Controller extends Vue {
  /**
   * 将来受取額シミュレーション画面サービス
   */
  private cahg1230Service = new CAHG1230Service()

  private inputTextPlaceHolder = ''
  private inputValidateErr = false
  private inputValidateErrInfo = {
    // 毎月の積立金額
    reservedAmountflg: false,
    reservedAmount: '',
    // 現在の積立金残高
    accumulatedBalanceflg: false,
    accumulatedBalance: '',
    // 運用期間
    operationPeriodflg: false,
    operationPeriod: '',
    // 運用利回り
    investmentYieldflg: false,
    investmentYield: ''
  }
  private MESSAGE_VALIDATE_ITEM = 'message-validate-item'

  /**
   * 将来受取額シミュレーション画面モデル
   */
  private cahg1230ViewModel: CAHG1230ViewModel = {
    reservedAmount: '',
    accumulatedBalance: '',
    operationPeriod: '',
    investmentYield: '3.00',

    dispFlg: false,
    loginFlg: false,
    showCalcAreaFlg: '',
    showAccumulatedBalanceModalFlg: false,

    receiveTotal: '',

    rsltDiv: null,

    listMessageValidate: []

  }

  mounted() {
    const fullPath = this.$route.fullPath
    if (!CommonUtil.isWhiteUrl(fullPath)) {
      this.cahg1230ViewModel.loginFlg = true
    }
    this.$nextTick(() => {
      fixedContent()
      fixedContentNoLogin()
    })
    // 初期処理メソッドを呼出す
    this.init()
  }

  /**
   * 初期処理
   */
  private init() {
    this.cahg1230ViewModel.reservedAmount = ''
    this.cahg1230ViewModel.accumulatedBalance = ''
    this.cahg1230ViewModel.operationPeriod = ''
    this.cahg1230ViewModel.investmentYield = '3.00'

    // システムアクティビティログを実行する（トランスポート）
    if (
      SessionStorageService.getItem(CommonConstants.USER_INFO) &&
      this.cahg1230ViewModel.loginFlg
    ) {
      TransportService.callAPITransport(
        CommonConstants.URL_CAHG1230,
        null,
        null
      )
    }
  }

  /*
   * 現在積立金残高のポップアップ呼び出し用メソッド
   */
  accumulatedBalanceModalOpen() {
    // 表示用フラグがtrueの場合、ポップアップ表示します。
    this.cahg1230ViewModel.showAccumulatedBalanceModalFlg = true
    $('.el-dialog__close').attr('tabindex', '100')
  }

  /*
   * 現在積立金残高のポップアップ閉じ用メソッド
   */
  accumulatedBalanceModalClose() {
    // 表示用フラグがfalseの場合、ポップアップを閉じます。
    this.cahg1230ViewModel.showAccumulatedBalanceModalFlg = false
  }

  /*
   * 閉じる用コールバック メソッド
   */
  closeModalCallBack() {
    console.log('closeModalCallBack')
  }

  /*
   * 表示用コールバック メソッド
   */
  openModalCallBack() {
    console.log('openModalCallBack')
  }

  /**
   * シミュレーショントップに戻るボタン押下
   */
  private gotoCAHG1010() {
    this.$router.push({ name: 'cahg1010' })
  }

  /**
   * かんたんシミュレーショントップに戻るボタン押下
   */
  private gotoCAHG1130() {
    this.$router.push({ name: 'cahg1130' })
  }

  /**
   * 年金受取額シミュレーションへ(ログイン前)ボタン押下
   */
  private gotoCAHG1220BeforLogin() {
    this.$router.push({ name: 'cahg1220BeforLogin' })
  }

  /**
   * 年金受取額シミュレーションへ(ログイン後)ボタン押下
   */
  private gotoCAHG1220() {
    this.$router.push({ name: 'cahg1220' })
  }

  /**
   * 計算する、再計算するボタン押下
   */
  private async gotoCAHG1230() {
    /* 入力項目のチェック処理を呼び出す */
    const listErrorMessage = this.cahg1230Service.validationInput(
      this.cahg1230ViewModel.reservedAmount,
      this.cahg1230ViewModel.accumulatedBalance,
      this.cahg1230ViewModel.operationPeriod,
      this.cahg1230ViewModel.investmentYield
    )

    this.cahg1230ViewModel.listMessageValidate = listErrorMessage

    if (listErrorMessage.length > 0) {
      /* 入力項目チェックにエラーがあった場合、計算結果エリアを表示させない */
      this.cahg1230ViewModel.dispFlg = false
      this.inputValidateErr = true
      this.inputTextPlaceHolder = '入力してください'

      /* 入力項目チェックエラー項目情報初期化 */
      this.inputValidateErrInfoClear()

      /* 入力項目チェックエラー項目情報設定 */
      this.setInputValidateErrInfoFlg(listErrorMessage)
    } else {
      this.inputValidateErr = false
      this.inputTextPlaceHolder = ''
      /* 入力項目チェックにエラーがなかった場合、将来受取額シミュレーション計算結果取得（CAHA1230)を呼ぶ  */
      const caha1230ResponseModel = await this.cahg1230Service.callAPICAHA1230(
        this.cahg1230ViewModel.reservedAmount,
        this.cahg1230ViewModel.accumulatedBalance,
        this.cahg1230ViewModel.operationPeriod,
        this.cahg1230ViewModel.investmentYield
      )

      /* APIを呼び出し、エラーがなかった場合に項目をViewModelの値に設定する */
      if (caha1230ResponseModel.rsltDiv === 1) {
        /* レスポンス項目に対応するViewModelを初期化する */
        this.cahg1230ViewModel.receiveTotal = ''
        Store.setResponseErrors(null)
        if (
          !CommonUtil.isNotEmpty(caha1230ResponseModel.receiveTotal)
        ) {
          this.cahg1230ViewModel.dispFlg = false
          const errorValid = []
          errorValid.push({
            code: 'MSGCAHG1230WF013',
            message: CommonUtil.getMessage('MSGCAHG1230WF013', [])
          })
          Store.setResponseErrors(errorValid)
          return
        }
        /* APIのレスポンス項目をViewModelに設定する */
        this.cahg1230ViewModel.receiveTotal =
          String(caha1230ResponseModel.receiveTotal)

        /* APIを呼び出し、エラーがなかった場合に計算結果エリアを表示させる */
        this.cahg1230ViewModel.dispFlg = true

        /* 将来受取額の計算結果エリアの表示制御をするためのフラグに値を設定 */
        this.cahg1230ViewModel.showCalcAreaFlg = '1'
      } else {
        /* APIを呼び出し、エラーがあった場合に計算結果エリアを表示させない */
        this.cahg1230ViewModel.dispFlg = false
      }
    }
    this.scrollToTop()
  }

  private scrollToTop() {
    $('html, body').animate(
      {
        scrollTop: 0
      },
      0
    )
  }

  private inputValidateErrInfoClear() {
    // 毎月の積立金額
    this.inputValidateErrInfo.reservedAmountflg = false
    this.inputValidateErrInfo.reservedAmount = ''
    // 現在の積立金残高
    this.inputValidateErrInfo.accumulatedBalanceflg = false
    this.inputValidateErrInfo.accumulatedBalance = ''
    // 運用期間
    this.inputValidateErrInfo.operationPeriodflg = false
    this.inputValidateErrInfo.operationPeriod = ''
    // 運用利回り
    this.inputValidateErrInfo.investmentYieldflg = false
    this.inputValidateErrInfo.investmentYield = ''
  }

  private setInputValidateErrInfoFlg(listErrorMessage) {
    listErrorMessage.forEach((errorValid) => {
      // エラーメッセージに該当する場合、エラー有（ture）を設定
      // 毎月の積立金額
      if (errorValid.code === 'MSGCAHG1230WF001' ||
          errorValid.code === 'MSGCAHG1230WF002' ||
          errorValid.code === 'MSGCAHG1230WF003') {
        this.inputValidateErrInfo.reservedAmountflg = true
      }
      // 現在の積立金残高
      if (errorValid.code === 'MSGCAHG1230WF004' ||
          errorValid.code === 'MSGCAHG1230WF005' ||
          errorValid.code === 'MSGCAHG1230WF006') {
        this.inputValidateErrInfo.accumulatedBalanceflg = true
      }
      // 運用期間
      if (errorValid.code === 'MSGCAHG1230WF007' ||
          errorValid.code === 'MSGCAHG1230WF008' ||
          errorValid.code === 'MSGCAHG1230WF009') {
        this.inputValidateErrInfo.operationPeriodflg = true
      }
      // 運用利回り
      if (errorValid.code === 'MSGCAHG1230WF010' ||
          errorValid.code === 'MSGCAHG1230WF011' ||
          errorValid.code === 'MSGCAHG1230WF012') {
        this.inputValidateErrInfo.investmentYieldflg = true
      }
    })

    // 入力項目チェックエラーの項目にCSSを設定
    this.setInputValidateErrInfoCss()
  }

  private setInputValidateErrInfoCss() {
    // 毎月の積立金額
    if (this.inputValidateErrInfo.reservedAmountflg) {
      this.inputValidateErrInfo.reservedAmount = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.reservedAmount = ''
    }
    // 現在の積立金残高
    if (this.inputValidateErrInfo.accumulatedBalanceflg) {
      this.inputValidateErrInfo.accumulatedBalance = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.accumulatedBalance = ''
    }
    // 運用期間
    if (this.inputValidateErrInfo.operationPeriodflg) {
      this.inputValidateErrInfo.operationPeriod = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.operationPeriod = ''
    }
    // 運用利回り
    if (this.inputValidateErrInfo.investmentYieldflg) {
      this.inputValidateErrInfo.investmentYield = this.MESSAGE_VALIDATE_ITEM
    } else {
      this.inputValidateErrInfo.investmentYield = ''
    }
  }
}
